import type {
    Group, GroupFetchParams, GroupClass, GroupInfoFetchParams, GroupMetadataMap,
} from "@godalming/api-types";
import { portalApi } from "@services/api/portalApi";
import { apiC } from "@services/api/apiC";

export async function fetchGroupData(params: GroupFetchParams): Promise<Group[]> {
    try {
        const response = await apiC.get<Group[]>(`/TeacherPortalGroupList`, {
            params: {
                type: params.type,
                acadYearFull: 2026,
                identifier: params.identifier, //params.mode === 'id' ? params.identifier : undefined,
            }
        });
        return response.data
    } catch (error) {
        console.error("Error fetching groups:", error);
        throw error;
    }
}

export type GroupMetadataFetchParams<T extends keyof GroupMetadataMap> = GroupInfoFetchParams & {
    type: T;
}

export async function fetchGroupMetadata<T extends keyof GroupMetadataMap>(
    params: GroupMetadataFetchParams<T>
): Promise<GroupMetadataMap[T]> {
    try {
        const response = await portalApi.get<GroupMetadataMap[T]>(`/academic-structure/${params.type}`, {
            params: {
                mode: params.mode,
                id: params.id,
            }
        })
        return response.data
    } catch (error) {
        console.error(`Error fetching ${params.type} metadata with ID ${params.id}:`, error);
        throw error;
    }
}

export async function fetchMyClasses(): Promise<GroupClass[]> {
    try {
        const response = await portalApi.get('/academic-structure/me/classes')
        return response.data
    } catch (error) {
        console.error("Error fetching my classes:", error);
        throw error;
    }
}
